import { elements, modifiers } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { ownerDocument } = button
    const sidebar = one(`.${elements.sidebar}`, ownerDocument)

    if (sidebar.classList.contains(modifiers.sidebar.open)) {
      sidebar.classList.remove(modifiers.sidebar.open)
      button.setAttribute('aria-expanded', 'false')
    } else {
      sidebar.classList.add(modifiers.sidebar.open)
      button.setAttribute('aria-expanded', 'true')
    }
  }
})

export default button => {
  onClick.listen(button)
}
